import styled from 'styled-components';
import { StyledHeader } from './Header/Header.style';
import { StyledTableHeaderRow } from 'components/base/Table/Table.styles';
import { STICKY_OFFSET } from 'components/base/common-styles';

export const StyledJiraStats = styled.div`
  & ${StyledHeader} {
    margin-bottom: 2rem;
  }
  & ${StyledTableHeaderRow} {
    top: calc(${props => props.offset}px - ${STICKY_OFFSET}rem) !important;
  }
`;
